function accessibilityForRadiosRechargeApp() {
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);

  const interval = setInterval(() => {
    const radioContainer = document.querySelector(".rc-template__radio");
    if(radioContainer) {
      const fieldset = document.createElement("fieldset");
      const legend = document.createElement("legend");
      legend.innerText = "Product purchasing options";
      legend.className = "visually-hidden";
      fieldset.appendChild(legend);
      radioContainer.querySelectorAll("label").forEach(item => {
        fieldset.appendChild(item);
      });
      radioContainer.appendChild(fieldset);

      clearInterval(interval);
      clearTimeout(timeout);
    }
  }, 200);
}

accessibilityForRadiosRechargeApp();

function fixListSemanticsToBlogs() {
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);

  const interval = setInterval(() => {
    const containerBlogs = document.querySelector(".zpa-post-container");
    
    if(!containerBlogs) {
      return;
    }

    containerBlogs.querySelectorAll('.zpa-post__item').forEach(article => {
      const thumbLink = article.querySelector('.zpa-thumbnail');
      const titleLink = article.querySelector('.zpa-post-title');
    
      const href = thumbLink?.getAttribute('href') || titleLink?.getAttribute('href');
      const title = thumbLink?.getAttribute('title') || titleLink?.getAttribute('title');
    
      // Replace thumbnail <a> with <span>
      if (thumbLink) {
        const spanThumb = document.createElement('span');
        spanThumb.className = thumbLink.className;
        spanThumb.style.cssText = thumbLink.style.cssText;
        spanThumb.setAttribute('role', 'presentation');
        thumbLink.replaceWith(spanThumb);
      }
    
      // Replace title <a> with <span> and its <h3> with <div>
      if (titleLink) {
        const spanTitle = document.createElement('span');
        spanTitle.className = titleLink.className;
    
        // Look for h3 inside titleLink and convert it to div
        const h3 = titleLink.querySelector('h3');
        if (h3) {
          h3.removeAttribute("title");
          const div = document.createElement('div');
          div.className = h3.className;
          while (h3.firstChild) {
            div.appendChild(h3.firstChild);
          }
          h3.replaceWith(div);
        }
    
        // Move remaining children
        while (titleLink.firstChild) {
          spanTitle.appendChild(titleLink.firstChild);
        }
    
        titleLink.replaceWith(spanTitle);
      }
    
      // Wrap everything inside <article> in a single outer <a>
      const wrapperLink = document.createElement('a');
      wrapperLink.href = href;
      wrapperLink.title = title;
      wrapperLink.style.display = 'block';
    
      while (article.firstChild) {
        wrapperLink.appendChild(article.firstChild);
      }
      wrapperLink.removeAttribute("title");
      article.appendChild(wrapperLink);
    });
    
    const container = document.querySelector(".zpa-post-container .flex-row");
    container.setAttribute("role", "list");
    container.setAttribute("aria-label", "Blog");
    const list = container.querySelectorAll("article");
    list.forEach(item => item.setAttribute("role", "listitem"));
    const linktexts = document.querySelectorAll(".zpa-blog-pagination__item .zpa-blog-pagination__link");
    linktexts.forEach(item => item.style.color="#757575");

    const placeholders = document.querySelectorAll(".zpa-text-field__label");
    placeholders.forEach(item => item.style.color="#757575");

    const searchBtn = document.querySelector(".zpa-btn-custom.zpa-header-search-button");
    searchBtn.setAttribute("aria-label", "Search content");

    clearInterval(interval);
    clearTimeout(timeout);
}, 300);
}

fixListSemanticsToBlogs();


function improveAccessibilityToProductDescription() {
    const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);
  
  const interval = setInterval(() => {
  const container = document.querySelector(".product__description.rte.quick-add-hidden");
    if(!container) return;

    const title = container.querySelector("h1");

    if(title) {
      const newTitle = document.createElement("h2");
      newTitle.innerText = title.innerText;
      newTitle.className = "h1";
      title.parentNode.insertBefore(newTitle, title);
      title.remove();
    }

    const subtitles = container.querySelectorAll("h5");
    subtitles.forEach(item => {
      const newTitle = document.createElement("div");
      newTitle.innerText = item.innerText;
      newTitle.className = "h5";
      item.parentNode.insertBefore(newTitle, item);
      item.remove();
    });

    clearInterval(interval);
    clearTimeout(timeout);
  }, 300);
}

improveAccessibilityToProductDescription();

function addAriaHiddenToStars(container) {
  if(!container) return;

  container.forEach(item => {
    item.setAttribute("aria-hidden","true");
    item.querySelectorAll(".appio-star").forEach(star => star.setAttribute("aria-hidden","true"));
  });
}

function addAriaHiddenAndTabIndexToFrequentlyBoughtImages() {
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);
  
  const interval = setInterval(() => {
    const data = document.querySelector(".cbb-frequently-bought-container");
    if(!data) return;

    data.setAttribute('role', 'group');

    const title = data.querySelector('.cbb-frequently-bought-title');
    if(title) {
      title.id = 'frequently_title_id'
      data.setAttribute('aria-labelledby', title.id);
    }

    const listContainer = data.querySelector('.cbb-frequently-bought-selector-list');
    if(listContainer) {
      listContainer.querySelectorAll('li').forEach((element, index) => {
        const checkbox = element.querySelector('input');
        const nextElement = checkbox.nextElementSibling;
        const price = element.querySelector('.cbb-frequently-bought-selector-label-regular-price');
        if(nextElement) {
          nextElement.id = 'element_' + index;
          price.id = 'price_' + index;
          const idsString = `${nextElement.id} ${price.id}`;
          checkbox.setAttribute('aria-labelledby', idsString);
          checkbox.removeAttribute('aria-label');
        }
      });
    }

    const items = data.querySelectorAll(".cbb-frequently-bought-product > *");

    setTimeout(() => {
      const stars = data.querySelectorAll(".appio-stars");
      addAriaHiddenToStars(stars);
    }, 2000);

    items.forEach(item => {
      item.setAttribute("aria-hidden", "true");
      item.setAttribute("tabindex", "-1");
    });

    clearInterval(interval);
    clearTimeout(timeout);
  }, 300);
}

addAriaHiddenAndTabIndexToFrequentlyBoughtImages();

function addListSemanticsToImageWithTextTemplates() {
  const imagesTemplates = document.querySelectorAll('div[id^="shopify-section-template"][id*="__image_with_text"]');

  if(imagesTemplates.length == 0) return;
  
  const parentContainer = document.createElement("div");
  parentContainer.setAttribute("role", "list");

  const firstTemplate = imagesTemplates[0];
  firstTemplate.parentNode.insertBefore(parentContainer, firstTemplate);
  
  imagesTemplates.forEach(item => {
    item.setAttribute("role", "listitem");
    parentContainer.appendChild(item);
  });
}
addListSemanticsToImageWithTextTemplates();

function changeContactFormTitle() {
  const target = document.querySelector('.powr-form-builder');
  
  if (target) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          if (target.classList.contains('powrLoaded')) {
            setTimeout(() => {
              const iframe = target.querySelector("iframe");
              iframe.removeAttribute("title");
              const title = window.location.pathname.includes('/social-media-influencer') ? 'Social Media Influencer' : 'Contact form'
              iframe.setAttribute("title", title);
            }, 1000)
          }
        }
      }
    });
  
    observer.observe(target, { attributes: true });
  }
}

  changeContactFormTitle();

function addStarsHiddenTextToAppioRating() {
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);
  
  const interval = setInterval(() => {
    const data = document.querySelectorAll(".card__information .appio-rating");

    if(data.length === 0) return;

    data.forEach(item => {
      const startVisuallyHidden = document.createElement("span");
      startVisuallyHidden.innerText = "stars";
      startVisuallyHidden.classList.add("visually-hidden");
      item.appendChild(startVisuallyHidden);
    });
      clearInterval(interval);
      clearTimeout(timeout);
  }, 300);
}

function addAriaHiddenToProductPageStars() {
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);
  
  const interval = setInterval(() => {
    const stars = document.querySelectorAll(".product__info-wrapper .appio-stars");

    if(stars.length === 0) return;

    const starContainer = document.querySelector(".product__info-wrapper .appio-rating-content");
    starContainer.setAttribute("tabindex", "0");
    starContainer.setAttribute("role", "link");
    starContainer.setAttribute('aria-describedby', 'product_title_id');//This id is on the product title html

    const dataNumber = document.querySelector(".appio-rating-badge .appio-rating");
    if(dataNumber) {
      const startVisuallyHidden = document.createElement("span");
      startVisuallyHidden.innerText = "stars";
      startVisuallyHidden.classList.add("visually-hidden");
      dataNumber.appendChild(startVisuallyHidden);
    } else {
      starContainer.setAttribute('aria-label', '0 reviews');
    }

    addAriaHiddenToStars(stars);
    clearInterval(interval);
    clearTimeout(timeout);
}, 300);
}

addAriaHiddenToProductPageStars();


function addAriaHiddenToProductCardStars() {
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);
  
  const interval = setInterval(() => {
    const stars = document.querySelectorAll(".card__information .appio-stars");

    if(stars.length === 0) return;

    addAriaHiddenToStars(stars);
    clearInterval(interval);
    clearTimeout(timeout);
}, 300);
}
  addAriaHiddenToProductCardStars();
  addStarsHiddenTextToAppioRating();

function addListSemanticsToAppioReviewsBox() {
  
  const timeout = setTimeout(() => {
    clearInterval(interval);
  }, 5000);
  
  const interval = setInterval(() => {
    const container = document.querySelector(".appio-reviews-widget");
    if(!container) return;

    setTimeout(() => {
      container.querySelectorAll(".appio-rating-line-qty").forEach((item, index) => {
        const numberOfStars = item.getAttribute("filter");
        const numberOfPercentage = item.getAttribute("count");

        if(index === 0) {
          const parent = item.parentNode;
          parent.setAttribute('role', 'list');
          parent.setAttribute('aria-label', 'Review distribution');
          parent.querySelectorAll('.appio-rating-line-star').forEach(element => {
            element.setAttribute('aria-hidden', 'true')
          });;
        }
        

        const span = document.createElement('span');
        item.setAttribute('role', 'listitem');
        span.setAttribute("aria-label", numberOfStars[1] +" stars "+numberOfPercentage + "%");
        span.setAttribute("role", "link");
        span.setAttribute("tabindex", "0");

        span.innerText = item.innerText;
        item.innerText = '';
        item.appendChild(span);
      });
      container.querySelectorAll(".appio-rating-line-bar").forEach(item => item.setAttribute("aria-hidden", "true"));
      addAriaHiddenToStars(container.querySelectorAll(".appio-stars"));
      const buttons = container.querySelectorAll(".appio-paging-box button");
      buttons.forEach(btn => {
        const pageNumber = btn.getAttribute("page");
        const isLast = btn.hasAttribute("last");
        const isFirst = btn.hasAttribute("first");
        btn.setAttribute("aria-label", "Go to page "+pageNumber);
        const hiddenText = document.createElement("span");
        hiddenText.classList.add("visually-hidden");
        if(isLast) {
          btn.setAttribute("aria-label", "Go to last page");
          hiddenText.innerText = "Go to last page";
          btn.appendChild(hiddenText);
        }
        if(isFirst) {
          btn.setAttribute("aria-label", "Go to first page");
          hiddenText.innerText = "Go to first page";
          btn.appendChild(hiddenText);
        }
        
        if(!btn.hasAttribute("active")){
          btn.addEventListener('click', () => {
            addListSemanticsToAppioReviewsBox();
          });
        }
      });

      const listReview = container.querySelector(".appio-reviews-box");
      if(listReview) {
        listReview.setAttribute("role", "list");
        listReview.setAttribute("aria-label", "Review");
        container.querySelectorAll(".appio-reviews-box img").forEach(item => item.setAttribute("alt", ""));
        container.querySelectorAll(".appio-review-item-holder").forEach(item => item.setAttribute("role", "listitem"));
      }

      addAccessibilityToReviewSortBtnMenu();
      
    }, 2000);

    const writeAReviewBtn = document.querySelector(".appio-review-button");
    if(writeAReviewBtn){
    writeAReviewBtn.addEventListener('click', () => {
      const modalContainer = document.querySelector(".appio-review-box");

      const parent = modalContainer.parentNode;
      parent.setAttribute('role', 'dialog');

      const title = modalContainer.querySelector(".appio-review-box-title");
      const newTitle = document.createElement("h1");
      newTitle.innerText = title.innerText;
      newTitle.className = title.className;
      newTitle.style.marginBottom = "0";
      newTitle.id = 'title_modal_review_id';
      title.parentNode.insertBefore(newTitle, title);
      title.remove();
      parent.setAttribute('aria-labelledby', newTitle.id);

      const closeBtn = modalContainer.querySelector(".appio-close-button");
      closeBtn.setAttribute("aria-label", "Close");
      closeBtn.setAttribute("tabindex", "0");
      closeBtn.setAttribute("role", "button");

      const fileBtn = modalContainer.querySelector(".appio-media-upload-button label");
      fileBtn.setAttribute("tabindex", "0");
      fileBtn.setAttribute("role", "button");
      fileBtn.setAttribute("aria-label", "File selection");

      const labels = modalContainer.querySelectorAll("#appio-review-rating label");
      const starSelectedText = modalContainer.querySelector(".appio-review-rating-box .appio-review-rating-notify");
      starSelectedText.setAttribute("aria-live", "polite");
      labels.forEach(item => item.setAttribute("aria-hidden", "true"));

      const nameInput = modalContainer.querySelector('#appio-review-input-name');
      const emailInput = modalContainer.querySelector('#appio-review-input-email');

      if(nameInput) {
        nameInput.setAttribute('autocomplete', 'name');
      }

      if(emailInput) {
        emailInput.setAttribute('autocomplete', 'email');
      }

      const inputs = modalContainer.querySelectorAll("input[type='text'], textarea");
      inputs.forEach((item, index) => {
        const placeHolder = item.getAttribute("placeHolder");

        //the first one is not required
        if(index !== 0 && !placeHolder.includes("*")) {
          item.setAttribute("placeholder", placeHolder + "*");
        }
        
        item.setAttribute("aria-label", placeHolder);
      });


      const container = document.querySelector('#appio-review-rating'); // the parent of all 5 inputs
      const inputs2 = container.querySelectorAll("input");
      inputs2.forEach(input => {
        input.addEventListener('focus', () => {
          container.classList.add('focus-visible');
        });

        input.addEventListener('blur', () => {
          // Wait a tick to check if any input still has focus
          setTimeout(() => {
            const isAnyInputFocused = Array.from(inputs2).some(el => el === document.activeElement);
            if (!isAnyInputFocused) {
              container.classList.remove('focus-visible');
            }
          }, 0);
        });
      });

      const submitBtn = modalContainer.querySelector('.appio-button-submit-review');
      if(submitBtn) {
        let observer = null;
        submitBtn.addEventListener('click', () => {
          setTimeout(() => {
            const errors = modalContainer.querySelectorAll('.rating-notify-alert, .appio-validation-message');
            errors.forEach((error, index) => {
              const previousInput = error.previousElementSibling;
              error.id = error.id ? error.id : 'error_'+index;
              if(index === 0) {
                if(previousInput.tagName === 'DIV') {
                  previousInput.querySelector('input').focus();
                } else {
                  previousInput.focus();
                }
              }

              if(previousInput.tagName === 'DIV') {
                previousInput.querySelectorAll('input').forEach(star => {
                  star.setAttribute('aria-describedby', error.id);
                });
              } else {
                previousInput.setAttribute('aria-describedby', error.id);
              }
            });
          }, 500);

          observer = new MutationObserver(() => {
            const successContainer = document.querySelector('.appio-msg-box');
            if(successContainer) {
              successContainer.setAttribute('role', 'alertdialog');
              trapFocusReviews(successContainer);
              observer.disconnect();
            }
          })

          observer.observe(document.body, {
            subtree: true,
            childList: true
          })
        });
      }

      


      trapFocusReviews(modalContainer);


      function trapFocusReviews(container) {
        const focusableSelectors = [
          'input:not([disabled])',
          'textarea:not([disabled])',
          'button:not([disabled])',
          '[tabindex="0"]:not([disabled])'
        ];

        const focusableElements = Array.from(container.querySelectorAll(focusableSelectors.join(',')))
          .filter(el => el.offsetParent !== null); // filter out hidden elements

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        container.addEventListener('keydown', (e) => {
          const activeElement = document.activeElement;

          if (e.key === 'Tab') {
            if (focusableElements.length === 0) return;

            if (e.shiftKey) {
              // Shift + Tab
              if (activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
              }
            } else {
              // Tab
              if (activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
              }
            }
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeBtn.click();
          }
        });

        firstElement.focus();
      }

    });
    }


    clearInterval(interval);
    clearTimeout(timeout);
  }, 500);
}
addListSemanticsToAppioReviewsBox();

function addAccessibilityToReviewSortBtnMenu() {
  const menu = document.querySelector('.appio-menu');

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(
      '[tabindex]:not([tabindex="-1"])'
    )).filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
  }

  function closeMenu() {
    if (menu) {
      menu.style.display = 'none';
    }
  }

  function trapFocus(container) {
    const focusableEls = getFocusableElements(container);
    const first = focusableEls[0];
    const last = focusableEls[focusableEls.length - 1];

    function handleKeyDown(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeMenu();
      }
    }

    container.addEventListener('keydown', handleKeyDown);
    return () => container.removeEventListener('keydown', handleKeyDown);
  }

  let removeTrap = null;

  if (menu) {
    const sortBtn = document.querySelector(".appio-sort-button");
    sortBtn.setAttribute("aria-label", "Sort reviews");
    const observer = new MutationObserver(() => {
      const isHidden = getComputedStyle(menu).display === 'none';

      menu.querySelectorAll('.appio-menu-item').forEach(el => {
        if (isHidden) {
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('tabindex', '-1');
          sortBtn.setAttribute("aria-expanded", "false");
        } else {
          el.removeAttribute('aria-hidden');
          el.setAttribute('tabindex', '0');
          el.setAttribute('role', 'button');
          sortBtn.setAttribute("aria-expanded", "true");
        }
      });

      if (!isHidden) {
        const focusable = getFocusableElements(menu);
        focusable[0]?.focus();
        removeTrap = trapFocus(menu);
      } else {
        if (removeTrap) removeTrap();
      }
    });

    observer.observe(menu, { attributes: true, attributeFilter: ['style'] });

    // Initial check
    const isHidden = getComputedStyle(menu).display === 'none';
    if (!isHidden) {
      const focusable = getFocusableElements(menu);
      focusable[0]?.focus();
      removeTrap = trapFocus(menu);
    } else {
      menu.querySelectorAll('*').forEach(el => {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
        sortBtn.setAttribute("aria-expanded", "false");
      });
    }
  }
}

function resolveColorContratInWhereToBuy() {
  setTimeout(() => {
    const item = document.querySelector(".sc-kkGfuU.ksaNeB");
    if(!item) return;
    item.style.background = '#000';
    item.style.color = '#fff';
  }, 3000)
}

resolveColorContratInWhereToBuy();

function addAriaLabelToLogoShopPayInProductDetails() {
  setTimeout(() => {
    const shopifyPaymentTerms = document.querySelector("shopify-payment-terms");

    if(!shopifyPaymentTerms) return;

    const icon = shopifyPaymentTerms.shadowRoot.querySelector("svg");
    const modal = document.querySelector("div[data-nametag='shop-portal-provider']");
    const title = modal.shadowRoot.querySelector(".flex-1.font-sans.text-body-large");
    const iconsModal = modal.shadowRoot.querySelectorAll("svg.text-purple-primary, div.text-purple-primary svg");
    const affirmIconModal = modal.shadowRoot.querySelector(".text-caption svg");
    const dialogButtonOpen = shopifyPaymentTerms.shadowRoot.querySelector("#shopify-installments-cta");
    const closeButton = modal.shadowRoot.querySelector("button[data-testid='authorize-modal-close-button']");

    icon.setAttribute("aria-label", "Shop pay logo");
    dialogButtonOpen.setAttribute("aria-label", "Learn more about Shop Pay");
    modal.setAttribute("aria-hidden", "true");
    
    dialogButtonOpen.addEventListener('click', () => {
      modal.removeAttribute("aria-hidden");

      const handleScape = (event) => {
        if(event.key === 'Escape') {
          modal.setAttribute("aria-hidden", "true");
          document.removeListener('keydown', handleScape);
        }
      };

      document.addEventListener('keydown', handleScape);

      closeButton.addEventListener("click", () => {
        modal.setAttribute("aria-hidden", "true");
        document.removeEventListener('keydown', handleEscape);
      });
    });
    
    affirmIconModal.setAttribute("aria-label", "Afirm logo");
    iconsModal.forEach(item => item.setAttribute("aria-label", "Shop pay logo"));
    title.setAttribute("aria-level","1");
    title.setAttribute("role","heading");
  }, 3000)
}

function toggleModal() {
  const shopifyPaymentTerms = document.querySelector('shopify-payment-terms');
  const modal = document.querySelector("div[data-nametag='shop-portal-provider']");
  if (!shopifyPaymentTerms || !modal || !modal.shadowRoot) return;

  const buttonClose = modal.shadowRoot.querySelector("button[data-testid='authorize-modal-close-button']");
  buttonClose.setAttribute("tabindex", "-1");
  const modalChild = modal.shadowRoot.querySelector("div[data-testid='authorize-modal-container']");
  const dialogButtonOpen = shopifyPaymentTerms.shadowRoot.querySelector("#shopify-installments-cta");

  if (!modalChild || !dialogButtonOpen || !buttonClose) return;

  // When modal is opened
  dialogButtonOpen.addEventListener('click', () => {
    requestAnimationFrame(() => {
      buttonClose.removeAttribute('tabindex');
    });
  });

  // When modal visibility changes
  const observer = new MutationObserver(() => {
    if (!modalChild.classList.contains('visible')) {
      buttonClose.setAttribute('tabindex', '-1');
    } else {
      buttonClose.removeAttribute('tabindex');
    }
  });

  observer.observe(modalChild, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

// Wait for elements to exist before calling
setTimeout(() => {
  toggleModal();
}, 1000);



addAriaLabelToLogoShopPayInProductDetails();

function listenToProductSubscriptionDetail() {
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      const targetDiv = document.querySelector('.rc-tooltip');
      if (targetDiv) {
        targetDiv.style.display = 'none';
      }
    }
  });
}

listenToProductSubscriptionDetail();

function addListSemanticsToCounter() {
  const countContainer = document.querySelector(".els-cup-w-wrap");
  if(countContainer) {
    countContainer.setAttribute("role","list");
    countContainer.setAttribute("aria-label", "Sustainability statistics");
  
    const items = countContainer.querySelectorAll(".els-cup-w");
    items.forEach(item => item.setAttribute("role","listitem"));
    const images = countContainer.querySelectorAll("img");
    images.forEach(item => {
      item.setAttribute("aria-hidden","true");
      item.setAttribute("alt", "");
    });
  }
}

setTimeout(() => {
  addListSemanticsToCounter()
}, 1000);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    if(isMobile) {
      this.change();
    }
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  change() {
        this.sliderItemsToShow = Array.from(this.sliderItems).map((item, index) => {
          if(index === 0) {
            parent = item.closest('ul');
          }
          const div = document.createElement('div');
          div.id = item.id;
          div.className = item.className;
          div.setAttribute('aria-label', item.getAttribute('aria-label'));
          div.innerHTML = item.innerHTML;
          item.replaceWith(div);
          return item;
        });
        if(parent) {
          const newParent = document.createElement('div');
          newParent.id = parent.id;
          newParent.className = parent.className;
          newParent.setAttribute('aria-label', parent.getAttribute('aria-label'));
          newParent.innerHTML = parent.innerHTML;
          parent.replaceWith(newParent);
        }
        
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
      if(this.currentPage - 1 !== 0) {
        this.prevButton.setAttribute("aria-label", `Page ${this.currentPage - 1} of ${this.totalPages}`);
      }

      if(this.currentPage + 1 <= this.totalPages) {
        this.nextButton.setAttribute("aria-label", `Page ${this.currentPage + 1} of ${this.totalPages}`);
      }
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }


    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    if (isMobile) {
      this.sliderItemsToShow.forEach(item => {
        const isVisible = this.isSlideVisible(item);
        const itemContainer = item.querySelector("a");
        itemContainer.setAttribute("tabindex", isVisible ? "0" : "-1")
        itemContainer.setAttribute('aria-hidden', String(!isVisible));
      });
    }
    
    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

  let observerInvisible;
  function handleFocus(event) {
    const invisibleAlert = document.querySelector('#invisible-alert');
    const slides = document.querySelector('.slideshow');
    invisibleAlert.setAttribute('aria-hidden', 'false');

    observerInvisible = new MutationObserver(() => {
      const visibleSlide = Array.from(slides.querySelectorAll('.slideshow__slide'))
      .find(el => el.getAttribute('aria-hidden') === 'false');
    
      if (visibleSlide) {
        invisibleAlert.innerHTML = '';
        const oldText = visibleSlide.querySelector('.banner__heading');
        const newText = document.createElement('p');
        newText.innerText = oldText.innerText;
        invisibleAlert.append(newText);
      }
    });

    observerInvisible.observe(slides, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    })
  }

  function handleBlur(event) {
    const invisibleAlert = document.querySelector('#invisible-alert');
    invisibleAlert.setAttribute('aria-hidden', 'true');
    invisibleAlert.innerHTML = '';
    if (observerInvisible) {
      observerInvisible.disconnect();
      observerInvisible = null;
    }
  }

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.sliderControlLinksArray.forEach(element => {
      element.addEventListener('focus', handleFocus);
      element.addEventListener('blur', handleBlur);
    });

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function playPauseVideo() {
  const video = document.getElementById("accessible-player");

  if(!video) return;

  const TITLES = [
    'Press'
  ];

  const IDLE_MS = 1600;

  function hasKeyboardFocus(wrapper) {
    const el = document.activeElement;
    return !!(el && wrapper.contains(el) &&
      (el.matches(':focus-visible') || el.matches('[role],button,input,[tabindex]:not([tabindex="-1"])')));
  }

  // Hide extra buttons inside a wrapper (your requirement)
  function pruneButtons(wrapper) {
    wrapper.querySelectorAll(
      '.able-button-handler-transcript,' +
      '.able-button-handler-slower,' +
      '.able-button-handler-faster,' +
      '.able-button-handler-restart, '+
      '.able-button-handler-preferences'
    ).forEach(el => { 
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');  
    });
  }

  // Until first play: force-hide controls/seekbar via inline style (beats CSS :hover)
  function gateControlsUntilStarted(wrapper) {
    const ctrl = wrapper.querySelector('.able-control-row');
    const seek = wrapper.querySelector('.able-seekbar-wrapper');
    if (ctrl && !wrapper.classList.contains('has-started')) {
      ctrl.style.display = 'none';
    }
    if (seek && !wrapper.classList.contains('has-started')) {
      seek.style.display = 'none';
    }
  }

  function ungateControls(wrapper) {
    const ctrl = wrapper.querySelector('.able-control-row');
    const seek = wrapper.querySelector('.able-seekbar-wrapper');
    if (ctrl) ctrl.style.display = '';   // remove inline override
    if (seek) seek.style.display = '';   // remove inline override
  }

  function initWrapper(wrapper, indexHint = null) {
    if (!wrapper || wrapper.__ytSkinInit) return;
    const video = wrapper.querySelector('video');
    if (!video) return;

    wrapper.__ytSkinInit = true;

    // Big center play button: hide while playing, show when paused/ended
    const bigBtn = wrapper.querySelector('.able-big-play-button');
    if (bigBtn) {
      // Optional labeling by index
      if (indexHint != null && TITLES[indexHint]) {
        bigBtn.setAttribute('aria-label', 'Play ' + TITLES[indexHint]);
      }
      const syncBigBtn = () => {
        const playing = !video.paused && !video.ended;
        bigBtn.style.display = playing ? 'none' : 'grid';
        bigBtn.setAttribute('aria-hidden', playing ? 'true' : 'false');
      };
      syncBigBtn();
      ['play','playing','pause','ended'].forEach(ev => video.addEventListener(ev, syncBigBtn));
    }

    // Idle/hover fade logic (only active after started)
    let idleTimer = null;
    function showControls() {
      if (!wrapper.classList.contains('has-started')) return; // gate
      wrapper.classList.add('controls-visible');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        const hovered = wrapper.matches(':hover');
        const focusInside = hasKeyboardFocus(wrapper);
        if (!hovered && !focusInside && !video.paused) {
          wrapper.classList.remove('controls-visible');
        }
      }, IDLE_MS);
    }
    function hideControlsIfAllowed() {
      if (!wrapper.classList.contains('has-started')) return;
      if (!video.paused && !hasKeyboardFocus(wrapper)) {
        wrapper.classList.remove('controls-visible');
      }
    }

    // First play: unlock controls for this instance
    function markStarted() {
      if (!wrapper.classList.contains('has-started')) {
        wrapper.classList.add('has-started');
        ungateControls(wrapper);     // allow controls/seekbar to render
      }
      showControls();
    }

    // Events
    ['mousemove','mouseenter','pointermove','pointerenter'].forEach(ev =>
      wrapper.addEventListener(ev, showControls, { passive: true })
    );
    wrapper.addEventListener('mouseleave', hideControlsIfAllowed, { passive: true });
    ['touchstart','touchmove'].forEach(ev =>
      wrapper.addEventListener(ev, showControls, { passive: true })
    );
    wrapper.addEventListener('focusin', showControls);
    wrapper.addEventListener('focusout', showControls);

    video.addEventListener('play', markStarted);
    video.addEventListener('pause', () => {
      if (!wrapper.classList.contains('has-started')) return;
      wrapper.classList.add('controls-visible');
      clearTimeout(idleTimer);
    });

    // If this video is already playing (autoplay/programmatic), mark as started
    if (!video.paused) markStarted();

    // Immediately gate controls (inline display:none) until started
    gateControlsUntilStarted(wrapper);

    // In case Able inserts controls after init, observe and gate/prune when they appear
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches('.able-control-row') || node.matches('.able-seekbar-wrapper')) {
            // Keep hidden until first play
            gateControlsUntilStarted(wrapper);
            pruneButtons(wrapper);
          }
        });
      }
    });
    mo.observe(wrapper, { childList: true, subtree: true });

    // Also prune existing buttons if they’re already in the DOM
    pruneButtons(wrapper);
  }

  // Initialize all current Able wrappers with a stable index for labeling
  function initAll() {
    document.querySelectorAll('.able-wrapper').forEach((w, i) => initWrapper(w, i));
  }

  // Able builds its DOM after the <video data-able-player> is processed.
  // Observe the document to catch wrappers/controls that appear later.
  const docMO = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('.able-wrapper')) {
          // Index hint by counting previous wrappers in DOM order
          const idx = [...document.querySelectorAll('.able-wrapper')].indexOf(node);
          initWrapper(node, idx);
        } else {
          node.querySelectorAll?.('.able-wrapper').forEach((w) => {
            const idx = [...document.querySelectorAll('.able-wrapper')].indexOf(w);
            initWrapper(w, idx);
          });
        }
      });
    }
  });
  docMO.observe(document.documentElement, { childList: true, subtree: true });

  // Kick off for anything already on the page
  initAll();

        (function () {
  const HIDE_DELAY_MS = 2000;

  function isFlex(el) {
    return window.getComputedStyle(el).display === 'flex';
  }

  function scheduleHide(el) {
    // avoid stacking timers
    if (el.__hideTimer) clearTimeout(el.__hideTimer);
    el.__hideTimer = setTimeout(() => {
      el.style.display = 'none';
    }, HIDE_DELAY_MS);
  }

  function watchAlert(el) {
    if (!(el instanceof Element) || el.__watchingAlert) return;
    el.__watchingAlert = true;

    
    el.querySelectorAll("button").forEach(btn => {
      btn.style.display = 'none';
      btn.setAttribute("tabindex", "-1");
      btn.setAttribute("aria-hidden", "true");
    })

    // If it's already flex, schedule hide now
    if (isFlex(el)) scheduleHide(el);

    // Watch for style/class changes that toggle display
    const mo = new MutationObserver(() => {
      if (isFlex(el)) scheduleHide(el);
    });
    mo.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    el.__mo = mo;
  }

  // Initialize existing alerts
  document.querySelectorAll('.able-alert').forEach(el => {
    watchAlert(el);
  });

  // Watch for future alerts being added
  const docMO = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('.able-alert')) watchAlert(node);
        node.querySelectorAll?.('.able-alert').forEach(watchAlert);
      });
    }
  });
  docMO.observe(document.documentElement, { childList: true, subtree: true });
})();

  /* ----- Optional: viewport height fallback for older iOS fullscreen (keeps height correct) ----- */
  const setVH = () => {
    document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
  };
  setVH();
  window.addEventListener('resize', setVH, { passive: true });
  window.addEventListener('orientationchange', () => setTimeout(setVH, 50), { passive: true });
  ['fullscreenchange','webkitfullscreenchange'].forEach(ev =>
    document.addEventListener(ev, () => setTimeout(setVH, 50), { passive: true })
  );
}

playPauseVideo();

    function appendLogoToPaymentMethod() {
        const paymentsContainer = document.querySelector('.footer__payment .list-payment');
        if(paymentsContainer) {
            paymentsContainer.querySelectorAll('title').forEach(element => {
                element.textContent = element.textContent + ' logo';
            });
        }
    }

    appendLogoToPaymentMethod();

    function changeAltFromMainLogo() {
      const img = document.querySelector('.header__heading .header__heading-link img');
      if(img) {
        img.setAttribute('alt', 'Pura Dor logo: Pure. Proven. Powerful');
      }
    }

    changeAltFromMainLogo();

    function hideNextAndPreviousBtnsFromScreenReaders() {
      const isLessThan900px = window.innerWidth < 900;
        if(isLessThan900px) {
          document.querySelectorAll('.slider-button--next, .slider-button--prev').forEach(element => {
            element.setAttribute('aria-hidden', 'true');
            element.setAttribute('tabindex', '-1');
          });
        }
    }

    hideNextAndPreviousBtnsFromScreenReaders();

    function setBlogHeroImageToNullText() {
      if(!window.location.pathname.includes('/blogs/content')) return;

      const img = document.querySelector('.article-template__hero-adapt img');

      if(img) {
        img.setAttribute('alt', '');
      }
    }

    setBlogHeroImageToNullText();

    function fixDiscountPopUp() {
      const observer = new MutationObserver(() => {
        const parentContainer = document.querySelector('#omnisend-forms-wrapper [role="dialog"]');
        
        if(!parentContainer) return;

        parentContainer.querySelectorAll('[class*="omnisend-form-"][class*="-field-container-"][class*="-input"]').forEach((input, index) => {
          const parent = input.parentNode;
          const warnings = parent.querySelectorAll('[aria-live="polite"]');
          
          warnings.forEach((element, indexIn) => {
            element.id= `modal_input_${index}_${indexIn}`;
            const previousId = input.getAttribute('aria-describedby') ? input.getAttribute('aria-describedby') : '';
            input.setAttribute('aria-describedby', `${previousId} ${element.id}`);
            const textcontainer = element.querySelector('div')
            const newtext = document.createElement('span');
            newtext.innerText = textcontainer.innerText;
            textcontainer.innerText = '';
            newtext.style.color = '#EB0000';
            textcontainer.appendChild(newtext);
          });
        });

        const listContainer = Array.from(parentContainer.querySelectorAll('[class*="omnisend-form-"][class*="-text-"]'))
          .find(el => el.querySelectorAll('p').length === 1);

        if (listContainer) {
          const paragraph = listContainer.querySelector('p');
          if (paragraph) {
            const html = paragraph.innerHTML;

            const parts = html.split(/<br\s*\/?>\s*<br\s*\/?>/i)
              .map(part => part.trim())
              .filter(Boolean);
            paragraph.innerHTML = '';
            paragraph.setAttribute('role', 'list');

            parts.forEach((text, index) => {
              const item = document.createElement('span');
              if(index !== 0) {
                item.setAttribute('role', 'listitem');
              } else {
                item.setAttribute('aria-hidden', 'true');
              }
              item.innerHTML = text;
              paragraph.appendChild(item);
              const br = document.createElement('br');
              br.setAttribute('aria-hidden', 'true');
              const br2 = document.createElement('br');
              br2.setAttribute('aria-hidden', 'true');
              paragraph.appendChild(br);
              paragraph.appendChild(br2);
            });
          }
        }

        observer.disconnect();
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true
    })
  }

  fixDiscountPopUp();

  function setNullAltToImages() {
    document.querySelectorAll('.empty-alt').forEach(element => {
      const image = element.querySelector('img');
      if(image) {
        image.setAttribute('alt', '');
      }
    });
  }

  setNullAltToImages();

  function addDescribedTextToButton() {
    document.querySelectorAll('.section-zp').forEach((element, index) => {
      const title = element.querySelector('.product-title-zp > *');
      const btn = element.querySelector('.add-to-cart-zp > *');
      console.log(title, btn)
      if(title && btn) {
        title.id = 'zp_title_'+index;
        btn.setAttribute('aria-describedby', title.id);
      }
    });
  }

  addDescribedTextToButton();

  function combineLists() {
    const sections = document.querySelectorAll('.list-zp-section');
    if(sections.length <= 1) return;

    const listContainer = sections[0].querySelector('.list-zp-section-row > *');
    if(!listContainer) return;
    listContainer.setAttribute('aria-label','Customer reviews');
    listContainer.setAttribute('role', 'list');
    sections.forEach((element, index) => {
      if(index !== 0) {
        let parentSection = null;
        element.querySelectorAll('.list-zp-section-row .zpa-flex--column').forEach((item, index) => {
          if(index === 0) {
            parentSection = item.closest('section');
          }
          item.setAttribute('role', 'listitem');
          listContainer.appendChild(item);
        });

        if(parentSection) {
          parentSection.remove();
        }
      } else {
        element.querySelectorAll('.list-zp-section-row .zpa-flex--column').forEach((item) => item.setAttribute('role', 'listitem'))
      }
    });
  }

  combineLists();

  function combineRows() {
    const list = document.querySelectorAll('.combine-list-rows');
    if(list.length <= 1) return;

    const listContainer = list[0].querySelector(':scope > *');
    if(!listContainer) return;
    listContainer.setAttribute('role', 'list');
    list.forEach((element, index) => {
      if(index !== 0) {
        element.querySelectorAll('.zpa-flex--column').forEach((item, index) => {
          if(index === 0) {
            parentSection = item.closest('section');
          }
          if(item.querySelector('img')) {
            item.setAttribute('role', 'listitem');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
          
          listContainer.appendChild(item);
        });
        element.remove();
      } else {
        element.querySelectorAll('.zpa-flex--column').forEach(col => col.setAttribute('role', 'listitem'));
      }
    });
  }

  combineRows();

  function setListSemanticsZP() {
    document.querySelectorAll('.list-zp > .zp').forEach(element => {
      element.setAttribute('role', 'list');
      element.querySelectorAll('.list-item-zp').forEach(listItem => {
        const item = listItem.closest('.zpa-flex--column');
        if(item) {
          item.setAttribute('role', 'listitem');
        }
      });
    });
  }

  setListSemanticsZP();

  function removeRedundantLinksFromZP() {
    const links = document.querySelectorAll(".list-zp a");
    const seen = new Map();

    links.forEach(link => {
      const href = link.href;

      if (!seen.has(href)) {
        seen.set(href, link);
      } else {
        const original = seen.get(href);

        link.removeAttribute("href");
        link.style.cursor = "pointer";
        link.style.textDecoration = "none";
        link.setAttribute("role", "link");
        link.setAttribute("tabindex", "0");

        link.addEventListener("click", e => {
          e.preventDefault();
          original.click();
        });

        link.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            original.click();
          }
        });
      }
    });
  }

  removeRedundantLinksFromZP();

  function setLabelToInput() {
    document.querySelectorAll('.zp-input-label').forEach(element => {
      const input = element.querySelector('.zpa-quantity-selector__input');
      if(input) {
        input.setAttribute('aria-label', input.getAttribute('title'));
        input.removeAttribute('title');
      }
    });
  }

  setLabelToInput();

  function altToAriaLabel() {
    document.querySelectorAll('.alt-to-aria-label').forEach(element => {
      const link = element.querySelector('a');
      const img = element.querySelector('a img');

      if(link && img) {
        link.setAttribute('role', 'link');
        link.setAttribute('tabindex', '0');
        link.setAttribute('aria-label', img.alt);
        img.setAttribute('alt', '');
      }
    });
  }

  altToAriaLabel();


  function addListAndSliderSemantics() {
    const elements = document.querySelectorAll('.carousel-zipy .zpa-mc-carousel__elements-container > *');
    if(!elements.length) return;

    const isMobile = window.innerWidth <= 767;

    if(!isMobile) {
        elements.forEach((element, index) => {
          if(index === 0) {
            const parent = element.parentNode;
            parent.setAttribute('role', 'list');
          }
          element.setAttribute('role', 'listitem');
        });
    } else {
        elements.forEach((element, index) => {
          element.setAttribute('role', 'group');
          element.setAttribute('aria-label', `Slide ${index + 1} of ${elements.length}`);
        });
    }

  }
  addListAndSliderSemantics();

console.log('RUN ACCESSIBILITY')